<template>
    <span v-if="product">
        <router-link :to="'/'+$constants.entities.Product.ROUTE+product.id" @click.stop v-html="formatSearchName(product.name, searchTerm)"></router-link>
    </span>
</template>
<style scoped>
</style>
<script>
    import { formatSearchName } from "../mixins/searchMixins";
    import { mapActions } from "vuex";
    function initialState() {
        return {
            saving: false,
            loading: false
        };
    }
    export default {
        name: "ProductLink",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
            product: Object,
            searchTerm: String
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack"
            ]),
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            formatSearchName
        },
        computed: {
        }
    };
</script>